import { render, staticRenderFns } from "./PaymentStatusCard.vue?vue&type=template&id=36f5804a&scoped=true"
import script from "./PaymentStatusCard.vue?vue&type=script&lang=js"
export * from "./PaymentStatusCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatusCard.vue?vue&type=style&index=0&id=36f5804a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5804a",
  null
  
)

export default component.exports